export default __webpack_public_path__ + "static/media/bees3.4b2b86e1.png";